import { schema } from 'normalizr';

const event = new schema.Entity('events', {}, {
  idAttribute: 'Id',
});

export const events = new schema.Array(event);

export default event;
